import React from 'react';
import { SingleMeetingPageType } from '../../../lib/api/custom-page.types';
import { SingleMeetingPageWrapper } from '../SingleMeetingWrapper/SingleMeetingPageWrapper';
import { arePageFlagsPending, useEventSettings } from '../../../lib/context-providers/event-settings-context/event-settings-context';

export const SingleMeetingCustomPage: React.FunctionComponent<SingleMeetingPageType> = (props: SingleMeetingPageType): JSX.Element | null => {
  const eventSettings = useEventSettings();
  if (arePageFlagsPending(eventSettings)) return null;

  if (props && props.meetingId) return <SingleMeetingPageWrapper {...props} />;
  return null;
};
